export const NAMESPACE = 'tpaExtensionTranslations'
export const TPA_LOADING_KEY = 'TPA_PRELOADER_LOADING'
export const TPA_LOADING_DEFAULT = 'Loading'
